import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const PortfolioItem = ({ item }) => {
  return (
    <div className={`col-lg-4 col-md-6 portfolio-item ${item.categories}`}>
      <div className="portfolio-wrap">
        <img src={item.image} className="img-fluid" alt={item.title} />
        <div className="portfolio-info">
          <h4>{item.title}</h4>
          <p></p>
          <div className="portfolio-links">
            <a
              href={item.image}
              data-gallery="portfolioGallery"
              className="portfolio-lightbox"
            >
              <i className="bx bx-plus"></i>
            </a>
            <Link
              to={item.link}
              className="portfolio-details-lightbox"
              title="Portfolio Details"
            >
              <i className="bx bx-link"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

PortfolioItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    categories: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default PortfolioItem;
